//React
//Components
import {
  AlphaInput,
  AlphaNumericInput,
  Button,
  Card,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
//Styles
import "./styles.scss";
import CartoonMan from "assets/cartoon-man.png";
import OfficeBuilding from "assets/office-building.jpeg";

const Landing = () => {
  //Constants
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [mobile, setMobile] = useState("");
  const [storySectionVisibility, setStorySectionVisibility] = useState(false);
  const storySectionRef: any = useRef(null);
  const [missionSectionVisibility, setMissionSectionVisibility] =
    useState(false);
  const missionSectionRef: any = useRef(null);
  const [visionSectionVisibility, setVisionSectionVisibility] = useState(false);
  const visionSectionRef: any = useRef(null);
  const [teamSectionVisibility, setTeamSectionVisibility] = useState(false);
  const teamSectionRef: any = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, true);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const onScroll = (event: any) => {
    const docViewTop = window.pageYOffset;
    const storySectionTop = storySectionRef?.current?.offsetTop - 800;
    const missionSectionTop = missionSectionRef?.current?.offsetTop - 800;
    const visionSectionTop = visionSectionRef?.current?.offsetTop - 800;
    const teamSectionTop = teamSectionRef?.current?.offsetTop - 800;
    if (docViewTop >= storySectionTop && !storySectionVisibility) {
      setStorySectionVisibility(true);
    }
    if (docViewTop >= missionSectionTop && !missionSectionVisibility) {
      setMissionSectionVisibility(true);
    }
    if (docViewTop >= visionSectionTop && !visionSectionVisibility) {
      setVisionSectionVisibility(true);
    }
    if (docViewTop >= teamSectionTop && !teamSectionVisibility) {
      setTeamSectionVisibility(true);
    }
  };

  //Return UI
  return (
    <Screen
      className="contact-us-screen"
      hasHeader
      hasFooter
      screenAnimationClass="no-animation"
    >
      {/* First Section */}
      <div className="landing-div h-70 pd-h-60 mr-v-20">
        <div className="bg-theme h-100 w-100 br-12 content">
          <FlexBox
            flexColumn
            justifyEvenly
            alignCenter
            className="text-section h-100"
          >
            <p className="clr-theme fs-16 font-heavy mr-b-20 text-center">
              CONTACT US
            </p>
            <p className="fs-48 w-70 mr-au text-center font-heavy animated fadeInDown delay-01s">
              We'd love to talk about how we can work togather
            </p>
            <p className="fs-20 w-70 mr-au text-center font-light animated fadeInDown delay-01s">
              The only corporate card and spend management platform designed to
              help you spend less
            </p>
            <FlexBox
              justifyEvenly
              className="w-50 animated fadeInDown delay-03s"
            >
              <Button text={"Get Started"} className="fs-20 pd-h-30 w-40" />
              <Button
                text={"View Pricing"}
                variant="outline"
                className="fs-20 w-40"
              />
            </FlexBox>
          </FlexBox>
        </div>
      </div>
      {/* Second Section */}
      <div
        className="input-section pd-h-60 mr-v-40 pd-v-60"
        ref={storySectionRef}
      >
        <Card className="pd-40">
          {storySectionVisibility && (
            <>
              <FlexBox justifyBetween className="">
                <TitleBlock
                  title={"Full Name"}
                  content={
                    <AlphaInput
                      value={fullName}
                      onChange={setFullName}
                      hasLabel
                      className="bg-theme no-border br-9 fs-20 animated fadeInUp delay-01s"
                    />
                  }
                  className="w-47"
                  titleClass="fs-18 font-medium"
                />
                <TitleBlock
                  title={"Your Email"}
                  content={
                    <AlphaInput
                      value={email}
                      onChange={setEmail}
                      hasLabel
                      className="bg-theme no-border br-9 fs-20 animated fadeInUp delay-02s"
                    />
                  }
                  className="w-47"
                  titleClass="fs-18 font-medium"
                />
              </FlexBox>
              <FlexBox justifyBetween className="mr-v-40">
                <TitleBlock
                  title={"Company Name"}
                  content={
                    <AlphaInput
                      value={company}
                      onChange={setCompany}
                      hasLabel
                      className="bg-theme no-border br-9 fs-20 animated fadeInUp delay-03s"
                    />
                  }
                  className="w-47"
                  titleClass="fs-18 font-medium"
                />
                <TitleBlock
                  title={"Mobile No."}
                  content={
                    <AlphaInput
                      value={mobile}
                      onChange={setMobile}
                      hasLabel
                      className="bg-theme no-border br-9 fs-20 animated fadeInUp delay-04s"
                    />
                  }
                  className="w-47"
                  titleClass="fs-18 font-medium"
                />
              </FlexBox>
              <textarea
                className="bg-theme no-border br-9 fs-20 mr-b-40 animated fadeInUp delay-05s"
                placeholder="How can we help you?"
              />
              <div className="w-40 mr-au">
                <Button text={"Send Message"} className="w-100 fs-14" />
              </div>
            </>
          )}
        </Card>
      </div>
      {/* Third Section */}
      <div
        className="mission-section pd-h-60 mr-v-40 pd-v-60"
        ref={missionSectionRef}
      >
        <p className="clr-theme fs-16 font-heavy mr-b-20">Location</p>
        {missionSectionVisibility && (
          <FlexBox justifyBetween>
            <div className="w-47">
              <p className="fs-44 mr-b-30 font-heavy animated fadeInUp delay-01s">
                Our Offices
              </p>
              <p className="fs-18 animated fadeInUp delay-03s">
                {" "}
                We're building the economic infrastructure for the internet.
                Business of every size, A living place for curiosity and
                collaboration.
              </p>
              <p className="animated fadeInUp delay-05s fs-16 font-heavy mr-b-10 mr-t-20">
                New York, USA
              </p>
              <p className="animated fadeInUp delay-05s fs-14 font-light mr-b-5">
                545 Park Avenue New York,
              </p>
              <p className="animated fadeInUp delay-05s fs-14 font-light mr-b-20">
                New York, 110017
              </p>
              <p className="animated fadeInUp delay-05s fs-16 font-heavy mr-b-10">
                New York, USA
              </p>
              <p className="animated fadeInUp delay-05s fs-14 font-light mr-b-5">
                545 Park Avenue New York,
              </p>
              <p className="animated fadeInUp delay-05s fs-14 font-light">
                New York, 110017
              </p>
            </div>
            <Image
              src={OfficeBuilding}
              className="tertiary-man animated fadeInUp delay-05s w-47 br-9"
            />
          </FlexBox>
        )}
      </div>
    </Screen>
  );
};

export default Landing;
